import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <motion.header initial={{
    opacity: 0,
    y: -12
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 1,
    ease: [0.22, 1, 0.36, 1]
  }} className={`fixed inset-x-0 top-0 z-50 transition-colors duration-700 ${scrolled ? 'bg-warmwhite/85 backdrop-blur-md border-b border-beige/70' : 'bg-transparent border-b border-transparent'}`} data-id="element-96" data-mp="2rmp1jec2twum">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4 sm:px-10 sm:py-5" data-id="element-97" data-mp="3baeieqih6cp2">
        <a href="#top" className="font-serif text-[1.05rem] tracking-[0.16em] text-ink-900 sm:text-lg" data-id="element-98" data-mp="3fb8bdyaryhot">
          COMUNIDAD FRESH
        </a>
        <span className="hidden font-sans text-[0.62rem] font-light uppercase tracking-widest text-ink-400 sm:block" data-id="element-99" data-mp="2wihz01aemglu">
          Fresh Guide #1
        </span>
      </div>
    </motion.header>;
}